import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import { ConfigManager } from "../config/ConfigManager.js";
import { AppContext } from "../AppContext.js";
import {
  FabricStyleSearchCriteria,
  PageListBean,
  RestFabricStyleListRequest,
  RestCustomerListRequest,
  CustomerSearchCriteria,
  RestReadRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { CustomerService } from "../services/CustomerService.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
export class FabricStyleLookupHandler extends LookupHandler {
  static contextType = AppContext;
  constructor(companyCode, attribute_name, customerCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.customerCode = customerCode;
    let resetCriteria = new FabricStyleSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new FabricStyleSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let fabricStyleLookupCriteria = new FabricStyleSearchCriteria();
    fabricStyleLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = FabricStyleLookupCriteraHandler(
      companyCode,
      fabricStyleLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      fabricStyleLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Description", "description", 0, false); //2
    this.addColumnDefinition("ProductType", "productTypeCode", 0, false);
    this.addColumnDefinition("Cost", "cost", 0, false); //3
    this.addColumnDefinition("Price", "retailPrice", 0, false);
    this.addColumnDefinition("Weight", "weight", 0, false);
    this.addColumnDefinition("WareHouse", "defaultWareHouseCode", 0, false);
  }
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.fabricStyleCodeContainingText)) {
      if (!isEmptyString(filterText)) {
        search.fabricStyleCodeContainingText = filterText;
        this.searchCriteria = new FabricStyleSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadFabricStyleList(lookup_dialog, pageNumber, search);
    }
  }
  loadFabricStyleList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new FabricStyleSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      criteria.fabricStyleName = searchCriteria.fabricStyleName;
      criteria.fabricStyleCodeContainingText =
        searchCriteria.fabricStyleCodeContainingText;
      criteria.fabricStyleNameContainingText =
        searchCriteria.fabricStyleNameContainingText;
      criteria.fabricStyleNameStartsWith =
        searchCriteria.fabricStyleNameStartsWith;
      criteria.fabricStyleCodeStartsWith =
        searchCriteria.fabricStyleCodeStartsWith;
      criteria.fabricStyleColorCode = searchCriteria.fabricStyleColorCode;
      criteria.inventoryUomCode = searchCriteria.inventoryUomCode;
      criteria.productTypeCode = searchCriteria.productTypeCode;
      criteria.patternTypeCode = searchCriteria.patternTypeCode;
      criteria.makeTypeCode = searchCriteria.makeTypeCode;
      criteria.isActive = true;
      if (!isEmptyString(this.customerCode)) {
        criteria.logisticCustomerCode = this.customerCode;
      } else {
        criteria.logisticCustomerCode = searchCriteria.logisticCustomerCode;
      }
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestFabricStyleListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    FabricStyleService.getFabricStylePageList(
      requestInput,
      (response) => this.loadFabricStyleListResponse(response, lookup_dialog),
      this.loadFabricStyleListError
    );
  };
  loadFabricStyleListResponse = (response, lookup_dialog) => {
    let fabricStyleList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles !== null
    ) {
      fabricStyleList = response.data.fabricStylePageList.fabricStyles;
      totalCount = response.data.fabricStylePageList.totalCount;
      currentPageNumber = response.data.fabricStylePageList.currentPage;
      pageSize = response.data.fabricStylePageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = fabricStyleList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadFabricStyleListError = (error) => {
    ShowError("Error : " + error);
  };
}
const FabricStyleLookupCriteraHandler = (
  companyCode,
  fabricStyleLookupCriteria
) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new FabricStyleSearchCriteria(),
        is3PL: false,
        makeTypes: [],
        countUOMs: [],
        patternTypes: [],
        productTypes: [],
        showAutoCompleteMakeTypeList: true,
        showAutoCompleteTypeList: true,
        showAutoCompletePatternTypeList: true,
        showAutoCompleteUOMList: true,
        patternTypePageListForAutoCompleteList: new Array(),
        typePageListForAutoCompleteList: new Array(),
        makeTypePageListForAutoCompleteList: new Array(),
        uomPageListForAutoCompleteList: new Array(),
        productTypeLookupHandler: null,
        isShowAutoCompleteCustomerList: false,
        customerPageListForAutoCompleteList: new Array(),
        customerLookupHandler: null,

        uomsLookupHandler: null,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      this.companyCode = companyCode;
      if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
        this.state.is3PL = true;
        this.setState({
          is3PL: true,
        });
      }
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.loadCacheDetails();
      // this.initLookupHandlers();
    }

    loadCacheDetails = () => {

      const attribute_cache = { ...this.cache };

      let patternTypes = this.state.patternTypes;
      let productTypes = this.state.productTypes;
      let countUOMs = this.state.countUOMs;
      let makeTypes = this.state.makeTypes;



      if (attribute_cache.uoms != null) {

        countUOMs = attribute_cache.uoms.filter((line) => line.isActive);
      }

      if (attribute_cache.makeTypes != null) {

        makeTypes = attribute_cache.makeTypes.filter((line) => line.isActive);
      }
      if (attribute_cache.patternTypes != null) {

        patternTypes = attribute_cache.patternTypes.filter((line) => line.isActive);

      }
      if (attribute_cache.productTypes != null) {

        productTypes = attribute_cache.productTypes.filter((line) => line.isActive);
      }
      this.setState({
        productTypes: productTypes,
        countUOMs: countUOMs,
        patternTypes: patternTypes,
        makeTypes: makeTypes,
      }, () => {
        this.initLookupHandlers()
      });
    };
    initLookupHandlers = () => {
      let uomsLookupHandler = new GenericAttributeLookupHandler(
        this.state.countUOMs,
        "UOM"
      );
      this.setState({ uomsLookupHandler: uomsLookupHandler });
      let productTypeLookupHandler = new GenericAttributeLookupHandler(
        this.state.productTypes,
        !this.props.is3PL ? "Pattern Type" : "Regulated"
      );
      this.setState({ productTypeLookupHandler: productTypeLookupHandler });
      let makeTypeLookupHandler = new GenericAttributeLookupHandler(
        this.state.makeTypes,
        "Product Type"
      );
      this.setState({ makeTypeLookupHandler: makeTypeLookupHandler });
      let patternTypeLookupHandler = new GenericAttributeLookupHandler(
        this.state.patternTypes,
        !this.props.is3PL ? "Type" : "Commodity"
      );
      this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
      let customerLookupHandler = new CustomerLookupHandler(
        this.companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      this.setState({ searchCriteria: new FabricStyleSearchCriteria() });
    };
    onPatternTypeCodeChange = (e) => {
      let productTypeCode = e.target.value;
      this.state.showAutoCompletePatternTypeList = true;
      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      if (isEmpty(productTypeCode)) {
        this.state.showAutoCompletePatternTypeList = false;
        let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
        let searchCriteria = this.state.searchCriteria;
        searchCriteria.productTypeCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: searchCriteria,
          patternTypePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && productTypeCode !== "") {
        this.readPatternTypeBySearchString(productTypeCode);
      }
      if (e.target.name == "productTypeCode") {
        temp_searchCriteria["productTypeCode"] = e.target.value;
        let productType_List = this.state.productTypes;
        productType_List.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["productTypeCode"] = line.code;
            this.state.showAutoCompletePatternTypeList = false;
            let showAutoCompleteList =
              this.state.showAutoCompletePatternTypeList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readPatternTypeBySearchString(searchString) {
      let patternTypeData = this.state.productTypes;
      let simpleAutoCompleteList = new Array();
      if (patternTypeData.length > 0 && patternTypeData != null) {
        patternTypeData.map((patternTypeDatas) => {
          let simpleItemBean = {
            code: patternTypeDatas.code,
            description: patternTypeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletePatternTypeLists) =>
          simpleAutoCompletePatternTypeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        patternTypePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    patternTypeEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let productTypeCode = e.target.value;
      temp_searchCriteria["productTypeCode"] = productTypeCode;
      let productType_List = this.state.productTypes;
      let productTypeCodeBean = null;
      productType_List.map((line) => {
        if (line.code == e.target.value) {
          productTypeCodeBean = line;
        }
      });
      if (!isEmpty(productTypeCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.productTypeCode = productTypeCodeBean.code;
        this.setState({
          searchCriteria: temp_searchCriteria,
          patternTypePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompletePatternTypeList = (showAutoCompleteList) => {
      this.setState({ showAutoCompletePatternTypeList: showAutoCompleteList });
    };
    displayAutoCompleteTypeList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteTypeList: showAutoCompleteList });
    };
    displayAutoCompleteMakeTypeList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteMakeTypeList: showAutoCompleteList });
    };
    onTypeCodeChange = (e) => {
      let patternTypeCode = e.target.value;
      this.state.showAutoCompleteTypeList = true;
      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteTypeList;
      if (isEmpty(patternTypeCode)) {
        this.state.showAutoCompleteTypeList = false;
        let showAutoCompleteList = this.state.showAutoCompleteTypeList;
        let searchCriteria = this.state.searchCriteria;
        searchCriteria.patternTypeCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: searchCriteria,
          typePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && patternTypeCode !== "") {
        this.readTypeBySearchString(patternTypeCode);
      }
      if (e.target.name == "patternTypeCode") {
        temp_searchCriteria["patternTypeCode"] = e.target.value;
        let productType_List = this.state.patternTypes;
        productType_List.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["patternTypeCode"] = line.code;
            this.state.showAutoCompleteTypeList = false;
            let showAutoCompleteList = this.state.showAutoCompleteTypeList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readTypeBySearchString(searchString) {
      let patternTypeData = this.state.patternTypes;
      let simpleAutoCompleteList = new Array();
      if (patternTypeData.length > 0 && patternTypeData != null) {
        patternTypeData.map((typeDatas) => {
          let simpleItemBean = {
            code: typeDatas.code,
            description: typeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletetypeLists) =>
          simpleAutoCompletetypeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({ typePageListForAutoCompleteList: filteredSuggestions });
    }
    typeEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let patternTypeCode = e.target.value;
      temp_searchCriteria["patternTypeCode"] = patternTypeCode;
      let productType_List = this.state.patternTypes;
      let patternTypeCodeBean = null;
      productType_List.map((line) => {
        if (line.code == e.target.value) {
          patternTypeCodeBean = line;
        }
      });
      if (!isEmpty(patternTypeCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.patternTypeCode = patternTypeCodeBean.code;
        this.setState({
          searchCriteria: temp_searchCriteria,
          typePageListForAutoCompleteList: new Array(),
        });
      }
    };
    onMakeTypeCodeChange = (e) => {
      let makeTypeCode = e.target.value;
      this.state.showAutoCompleteMakeTypeList = true;
      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
      if (isEmpty(makeTypeCode)) {
        this.state.showAutoCompleteMakeTypeList = false;
        let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
        let searchCriteria = this.state.searchCriteria;
        searchCriteria.makeTypeCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: searchCriteria,
          makeTypePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && makeTypeCode !== "") {
        this.readMakeTypeBySearchString(makeTypeCode);
      }
      if (e.target.name == "makeTypeCode") {
        temp_searchCriteria["makeTypeCode"] = e.target.value;
        let productType_List = this.state.makeTypes;
        productType_List.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["makeTypeCode"] = line.code;
            this.state.showAutoCompleteMakeTypeList = false;
            let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readMakeTypeBySearchString(searchString) {
      let makeTypeData = this.state.makeTypes;
      let simpleAutoCompleteList = new Array();
      if (makeTypeData.length > 0 && makeTypeData != null) {
        makeTypeData.map((makeTypeDatas) => {
          let simpleItemBean = {
            code: makeTypeDatas.code,
            description: makeTypeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletetypeLists) =>
          simpleAutoCompletetypeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        makeTypePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    makeTypeEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let makeTypeCode = e.target.value;
      temp_searchCriteria["makeTypeCode"] = makeTypeCode;
      let productType_List = this.state.makeTypes;
      let makeTypeCodeBean = null;
      productType_List.map((line) => {
        if (line.code == e.target.value) {
          makeTypeCodeBean = line;
        }
      });
      if (!isEmpty(makeTypeCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.makeTypeCode = makeTypeCodeBean.code;
        this.setState({
          searchCriteria: temp_searchCriteria,
          makeTypePageListForAutoCompleteList: new Array(),
        });
      }
    };
    onUOMCodeChange = (e) => {
      let inventoryUomCode = e.target.value;
      this.state.showAutoCompleteUOMList = true;
      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteUOMList;
      if (isEmpty(inventoryUomCode)) {
        this.state.showAutoCompleteUOMList = false;
        let showAutoCompleteList = this.state.showAutoCompleteUOMList;
        let searchCriteria = this.state.searchCriteria;
        searchCriteria.inventoryUomCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: searchCriteria,
          uomPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && inventoryUomCode !== "") {
        this.readUomCodeBySearchString(inventoryUomCode);
      }
      if (e.target.name == "inventoryUomCode") {
        temp_searchCriteria["inventoryUomCode"] = e.target.value;
        let uom_List = this.state.countUOMs;
        uom_List.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["inventoryUomCode"] = line.code;
            this.state.showAutoCompleteUOMList = false;
            let showAutoCompleteList = this.state.showAutoCompleteUOMList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readUomCodeBySearchString(searchString) {
      let uomCodeData = this.state.countUOMs;
      let simpleAutoCompleteList = new Array();
      if (uomCodeData.length > 0 && uomCodeData != null) {
        uomCodeData.map((uomCodeDatas) => {
          let simpleItemBean = {
            code: uomCodeDatas.code,
            description: uomCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteUomCodeLists) =>
          simpleAutoCompleteUomCodeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({ uomPageListForAutoCompleteList: filteredSuggestions });
    }
    uomEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let inventoryUomCode = e.target.value;
      temp_searchCriteria["inventoryUomCode"] = inventoryUomCode;
      let productType_List = this.state.countUOMs;
      let inventoryUomCodeBean = null;
      productType_List.map((line) => {
        if (line.code == e.target.value) {
          inventoryUomCodeBean = line;
        }
      });
      if (!isEmpty(inventoryUomCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.inventoryUomCode = inventoryUomCodeBean.code;
        this.setState({
          searchCriteria: temp_searchCriteria,
          uomPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteUomList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteUomList: showAutoCompleteList });
    };
    errorCallBack = (error) => {
      ShowError(error);
    };
    onCustomerCodeChange = (e) => {
      let logisticCustomerCode = e.target.value.toUpperCase();
      this.state.isShowAutoCompleteCustomerList = true;
      let searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      if (isEmpty(logisticCustomerCode)) {
        this.state.isShowAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.logisticCustomerCode = "";

        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "logisticCustomerCode" &&
        showAutoCompleteList === true &&
        logisticCustomerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      searchCriteria[e.target.name] = e.target.value.toUpperCase();
      this.setState({ searchCriteria: searchCriteria });
    };

    customerCodeEnterKeyEventHandler = (e) => {
      let logisticCustomerCode = e.target.value;
      this.readCustomer(e.target.value);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };

    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = this.companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new PageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;

      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }

    readByCustomerCodeResponse = (response) => {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };

    readCustomerResponse = (response) => {
      const customerData = response.data.customer;
      let searchCriteria = this.state.searchCriteria;
      if (customerData != null) {
        searchCriteria.logisticCustomerCode = customerData.code;
        this.setState({ searchCriteria: searchCriteria });
      }
    };
    readCustomer = (logisticCustomerCode) => {
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = this.companyCode;
      readrestInput.code = logisticCustomerCode;
      readrestInput.isLoadChildren = false;
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerResponse,
        this.errorCallBack
      );
    };

    displayAutoCompleteCustomerList = (showAutoCompleteList) => {
      this.setState({ isShowAutoCompleteCustomerList: showAutoCompleteList });
    };

    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <Container>
            {is3PL ? (
              <Row>
                <Col sm={5}>
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm={7}>
                  <InputTextbox
                    // tabIndex={+2}
                    id="logisticCustomerCode"
                    name="logisticCustomerCode"
                    value={searchCriteria.logisticCustomerCode}
                    lookupRequired={true}
                    enableAutoCompleteTextBox={true}
                    enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                    onChange={this.onCustomerCodeChange}
                    lookupHandler={this.state.customerLookupHandler}
                    autoCompleteListData={
                      this.state.customerPageListForAutoCompleteList
                    }
                    displayAutoCompleteList={
                      this.displayAutoCompleteCustomerList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteCustomerList
                    }
                  />
                </Col>
              </Row>
            ) : null}
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle#</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  ref={this.focusRef}
                  // tabIndex={-1}
                  id="fsCode"
                  name="fabricStyleCode"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>ItemCode Starts With</FormLabel>
                ) : (
                  <FormLabel>FabricCode Starts With</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={-1}
                  id="fabricStyleCodeStartsWith"
                  name="fabricStyleCodeStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleCodeStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>ItemCode Contains</FormLabel>
                ) : (
                  <FormLabel>FabricCode Contains</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={-1}
                  id="fabricStyleCodeContainingText"
                  name="fabricStyleCodeContainingText"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleCodeContainingText}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>ItemName</FormLabel>
                ) : (
                  <FormLabel>fabricName</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={-1}
                  id="fabricStyleName"
                  name="fabricStyleName"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleName}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>ItemName Starts With</FormLabel>
                ) : (
                  <FormLabel>fabricName Starts With</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fabricStyleNameStartsWith"
                  name="fabricStyleNameStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleNameStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>ItemName Contains</FormLabel>
                ) : (
                  <FormLabel>fabricName Contains</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fabricStyleNameContainingText"
                  name="fabricStyleNameContainingText"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleNameContainingText}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Style</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={+2}
                  id="productTypeCode"
                  name="productTypeCode"
                  onChange={this.onPatternTypeCodeChange}
                  value={searchCriteria.productTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.productTypeLookupHandler}
                  enterKeyEventHandler={this.patternTypeEnterKeyEvent}
                  autoCompleteListData={
                    this.state.patternTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePatternTypeList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompletePatternTypeList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Type</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={+2}
                  id="patternTypeCode"
                  name="patternTypeCode"
                  onChange={this.onTypeCodeChange}
                  value={searchCriteria.patternTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.patternTypeLookupHandler}
                  enterKeyEventHandler={this.typeEnterKeyEvent}
                  autoCompleteListData={
                    this.state.typePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteTypeList}
                  showAutoCompleteList={this.state.showAutoCompleteTypeList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Content</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={+2}
                  id="makeTypeCode"
                  name="makeTypeCode"
                  onChange={this.onMakeTypeCodeChange}
                  value={searchCriteria.makeTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.makeTypeLookupHandler}
                  enterKeyEventHandler={this.makeTypeEnterKeyEvent}
                  autoCompleteListData={
                    this.state.makeTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteMakeTypeList}
                  showAutoCompleteList={this.state.showAutoCompleteMakeTypeList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Inventory UOM</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={+2}
                  id="inventoryUomCode"
                  name="inventoryUomCode"
                  onChange={this.onUOMCodeChange}
                  value={searchCriteria.inventoryUomCode}
                  lookupRequired={true}
                  lookupHandler={this.state.uomsLookupHandler}
                  enterKeyEventHandler={this.uomEnterKeyEvent}
                  autoCompleteListData={
                    this.state.uomPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteUomList}
                  showAutoCompleteList={this.state.showAutoCompleteUOMList}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
